import { resolveLocationScan } from './location-identifiers.mjs';

export default {
  data() {
    return { aliasMode: false, aliasWarehouse: null, aliasWarehouses: [], aliasAvailable: false,
      aliasBusy: false, aliasError: '', aliasRequestVersion: 0 };
  },
  mounted() {
    const service = this.$service && this.$service.storagePlace;
    if (service && service.identifierCapabilities) {
      service.identifierCapabilities().then((result) => { this.aliasAvailable = result.locationAliases === true; })
        .catch(() => { this.aliasAvailable = false; });
    }
  },
  beforeUnmount() { this.aliasRequestVersion += 1; },
  watch: {
    aliasWarehouse() { this.aliasRequestVersion += 1; },
    aliasMode() { this.aliasRequestVersion += 1; this.aliasError = ''; },
  },
  methods: {
    async filterAliasWarehouses(value, update) {
      try {
        const result = await this.$service.warehouse.getAll({ search: value, per_page: 50 });
        update(() => { this.aliasWarehouses = result.items || []; });
      } catch (error) { this.aliasError = error.message || 'Unable to load warehouses'; }
    },
    async submitLocationAlias() {
      if (this.aliasBusy) return;
      this.aliasBusy = true;
      this.aliasError = '';
      const requestVersion = this.aliasRequestVersion;
      const raw = this.barcode;
      try {
        const scan = await resolveLocationScan(this.$service.storagePlace, raw, this.aliasWarehouse);
        if (requestVersion !== this.aliasRequestVersion) return;
        this.$emit('barcode', scan);
        if (this.barcode === raw) this.barcode = '';
      } catch (error) { if (requestVersion === this.aliasRequestVersion) this.aliasError = error.message || 'Location label was not accepted'; }
      finally { this.aliasBusy = false; }
    },
  },
};
